import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiModel, AccessRight } from 'models';
import { Organization } from '../types';

@Injectable()
export class OrganizationModel {
    constructor(private apiModel: ApiModel) {}

    public putProfile(
        organizationId: string,
        data: Pick<Organization, 'name' | 'address'>
    ): Promise<Pick<Organization, 'name' | 'address'>> {
        return this.apiModel.makeHttpRequest({
            url: `${this.apiModel.getOrganizationsEndpoint()}/${organizationId}/profile`,
            method: 'put',
            body: data
        });
    }

    public getAllowedBrands(accessRight: AccessRight, retailerId: string): Observable<AllowedBrand[]> {
        return this.apiModel.makeHttpObservableRequest({
            url: `${this.apiModel.getOrganizationsEndpoint()}/allowedBrands/${accessRight}?retailerId=${retailerId}`,
            method: 'get'
        });
    }
}

export interface AllowedBrand {
    _id: string;
    name: string;
    isPremium: boolean;
    isFollowed: boolean;
    hasMarketingFiles: boolean;
    hasProductData: boolean;
}
